@use '@lib/assets/styles/main.scss' as *;

.optionWrap {
  position: relative;
  margin-bottom: 24px;
}

.optionDeleteBtn {
  position: absolute;
  top: 36px;
  right: 8px;
  transform: translateY(-50%);
}
